import { SVGProps } from 'react';

const IcNumber = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
    <path
      d='M17.5969 10.2421L16.8625 13.6692H19.6887V16.4508H16.2617L15.4606 20.2339H12.5008L13.302 16.4508H9.25183L8.45071 20.2339H5.51325L6.31438 16.4508H2.9541V13.6692H6.91522L7.64958 10.2421H4.31156V7.46043H8.25043L9.0293 3.76636H11.9668L11.1879 7.46043H15.238L16.0169 3.76636H18.9766L18.1977 7.46043H21.0462V10.2421H17.5969ZM14.6372 10.2421H10.587L9.85268 13.6692H13.9028L14.6372 10.242１Z'
      fill={props.fill || '#232F3E'}
    />
  </svg>
);

export default IcNumber;
